/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dob/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Dob({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Dob"
  
}) {
let cardPatientBirthdateValueData = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'patient.birthDate',
format: fromFormat.dateISOIn,
})
let cardMatchBirthdateValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.birthDate',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={!cardMatchBirthdateValueData ? dtColorsRed900 : dtColorsNeutral900}
 data="card.patient.birthDate"
 format="/Data/format.js dateISOIn"
 text={cardPatientBirthdateValueData}
 data="card.match.birthDate"
/>
{children}
</React.Fragment>)
}